"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EndEventViewModel = void 0;
const EventBaseViewModel_1 = require("./EventBaseViewModel");
class EndEventViewModel extends EventBaseViewModel_1.EventViewModel {
    constructor(endEvent, processModel) {
        var _a, _b, _c;
        super(endEvent, processModel);
        this.errorName = (_a = endEvent.errorEventDefinition) === null || _a === void 0 ? void 0 : _a.name;
        this.errorCode = (_b = endEvent.errorEventDefinition) === null || _b === void 0 ? void 0 : _b.code;
        this.errorMessage = (_c = endEvent.errorEventDefinition) === null || _c === void 0 ? void 0 : _c.message;
    }
}
exports.EndEventViewModel = EndEventViewModel;
//# sourceMappingURL=EndEventViewModel.js.map